module.exports = __webpack_public_path__ + "agenda-white-i.png";